// extracted by mini-css-extract-plugin
export default {"blue":"#2f80ed","red":"#eb5757","yellow":"#f2c94c","grey_6":"#333","grey_3":"#bdbdbd","graph_font_color":"#828282","border_color":"#e0e0e0"};